type EventHandler<T = unknown> = (payload: T) => void;

export const DesktopEvents = {
  FOCUS_CHANGED: "desktop:focus-changed",
  PALETTE_TOGGLE: "desktop:palette-toggle",
  SEARCH_TOGGLE: "desktop:search-toggle",
  SIDEBAR_HINTS: "desktop:sidebar-hints",
  BARCODE_SCANNED: "desktop:barcode-scanned",
} as const;

class EventBus {
  private handlers = new Map<string, Set<EventHandler>>();

  on<T>(eventName: string, handler: EventHandler<T>) {
    if (!this.handlers.has(eventName)) {
      this.handlers.set(eventName, new Set());
    }
    this.handlers.get(eventName)?.add(handler as EventHandler);

    return () => this.off(eventName, handler);
  }

  off<T>(eventName: string, handler: EventHandler<T>) {
    this.handlers.get(eventName)?.delete(handler as EventHandler);
  }

  emit<T>(eventName: string, payload: T) {
    this.handlers.get(eventName)?.forEach((handler) => {
      handler(payload);
    });
  }
}

export const desktopBus = new EventBus();
